import I from 'immutable'
import * as A from './actions'
import * as Env from 'domain/env'
import { Action } from 'redux'

interface ActionType extends Action {
  payload: any
}

const State = I.fromJS({
  certificationsList: I.List(),
  certification: I.Map()
})

export const reducer = {
  certification(state = State, action: ActionType) {
    switch (action.type) {
      case A.certificationsList.success:
        return state.set('certificationsList', action.payload)
      case A.certification.success:
        return state.set('certification', action.payload)
      case Env.signOut.success:
        return State

      default:
        return state
    }
  }
}
